export default {
  // mfa endpoints
  enrollMfaEndpoint: '/mfa/enroll',
  resendMfaOTPEndpoint: '/mfa/otp/resend', // same as the enroll MFA
  deactivateMfaEndpoint: '/mfa/deactivate',
  verifyAndActivateMfaEndpoint: '/mfa/activate',
  requestDeactivateMfaEndpoint: '/mfa/deactivate-request',
  validateAndAuthenticateEndpoint: '/mfa/authenticate',
  verifyMFAPasswordResetRequestEndpoint: '/mfa/verify-password-reset-request'
}
